<template>
  <div>
    <div v-show="toolbarActive" class="flex-wrap mt-8 d-flex align-center">
      <div>
        <span class="font-weight-medium toolbar-title">{{ toolbarTitle }}</span>
        <!-- Temporarily disabled plan restriction indicator -->
        <!-- <limited-feature-pill v-if="permission" :permission="permission" hide /> -->
      </div>
      <v-spacer />
      <div v-if="$route.path !== '/overview'">
        <p-btn
          class="mr-2 lowercase"
          @click="
            helpModalActive = true;
            SGVideos();
          "
        >
          {{ $t('Drawer.Help') }}
        </p-btn>
      </div>
      <p-btn
        v-if="showSmartButton"
        :disabled="!canAddSmartReviewsOnSelectedPlan"
        @click="switchHelpfulnessPrediction"
      >
        <span class="white--text">{{ $t('SmartReviews.addSmart') }}</span>
      </p-btn>
      <!--      <v-btn-->
      <!--        v-else-if="accountInfo.planName !== 'Enterprise'"-->
      <!--        elevation="0"-->
      <!--        class=""-->
      <!--        color="upgrade_button"-->
      <!--        :to="'/plan-pick'"-->
      <!--      >-->
      <!--        <span class="white&#45;&#45;text">{{ $t('Drawer.upgrade') }}</span>-->
      <!--      </v-btn>-->

      <!--      <v-dialog v-model="helpModalActive">-->
      <help-videos
        v-model="helpModalActive"
        :toolbar-title="$route.name"
        @closeModal="stopVideo"
        @setPlayerId="setPlayerId"
        @click:outside="stopVideo"
      />
      <!--      </v-dialog>-->
      <confirm-payment-dialog v-model="confirmDialog" :link="confirmLink" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
// import LimitedFeaturePill from '@/components/core/LimitedFeaturePill';
import HelpVideos from '@/components/core/HelpVideos';
import ConfirmPaymentDialog from '@/components/account/ConfirmPaymentDialog';
import PBtn from '@/components/polaris/PBtn';

export default {
  name: 'Toolbar',
  components: { HelpVideos, ConfirmPaymentDialog, PBtn },
  data: () => ({
    permission: null,
    responsive: false,
    responsiveInput: false,
    helpModalActive: false,
    playerId: null,
    confirmDialog: false,
    confirmLink: '',
  }),

  watch: {
    $route(val) {
      const titleRoute = (val.matched && val.matched[0]) || val;

      const key = titleRoute.meta ? titleRoute.meta.title || titleRoute.name : titleRoute.name;
      this.setToolbarTitle(key ? this.$t('Drawer.' + key) : '');
      this.permission = val.meta.permission;
    },
  },

  mounted() {
    this.onResponsiveInverted();
    window.addEventListener('resize', this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResponsiveInverted);
  },
  computed: {
    ...mapState(['accountInfo', 'toolbarActive', 'toolbarTitle']),
    ...mapGetters(['canAddSmartReviewsOnPlan']),
    canAddSmartReviewsOnSelectedPlan() {
      return this.canAddSmartReviewsOnPlan(this.accountInfo.activePlanId);
    },
    showSmartButton() {
      return !this.smartReviewsEnabled && this.$route.path === '/smart-reviews';
    },
    smartReviewsEnabled() {
      return this.accountInfo?.activeAddons?.indexOf('smart_reviews') >= 0;
    },
  },
  methods: {
    ...mapActions(['setToolbarTitle', 'postToggleAddon']),
    ...mapActions(['trackAnalytics']),
    ...mapActions(['showToastMessage']),
    switchHelpfulnessPrediction() {
      this.confirmLink = '';
      this.confirmDialog = true;

      this.postToggleAddon('smart_reviews')
        .then(res => {
          this.confirmLink = res.confirmationRedirectUrl;
          this.trackAnalytics('Smart Reviews - Paid Addon Button');
        })
        .catch(() => {
          this.showToastMessage({
            text: this.$t('Account.snackbarErrorText'),
            color: 'toast_error',
          });
        });
    },
    SGVideos() {
      this.trackAnalytics('Header VideoTutorials');
    },
    stopVideo() {
      this.helpModalActive = false;
      this.setPlayerId = null;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
        this.responsiveInput = false;
      } else {
        this.responsive = false;
        this.responsiveInput = true;
      }
    },
    setPlayerId(playerId) {
      this.playerId = playerId;
    },
  },
};
</script>

<style lang="scss">
.v-toolbar__content {
  flex-wrap: inherit;
}

.toolbar-title {
  color: #202223;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1.5rem;
}
</style>
